import React, { PropsWithChildren } from 'react';

import styles from './styles.module.css';

export const ErrorOverlayBottom: React.FC<PropsWithChildren> = ({ children }) => (
    <div className={styles.bottom}>{children}</div>
);
